// extracted by css-extract-rspack-plugin
export default {"button":"button-YbDwjY","icon":"icon-hV7Jpt","text":"text-ZbD5De"};